import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SymptomsSection } from './components/SymptomsSection';
import { DiagnosisSection } from './components/DiagnosisSection';
import { SolutionSection } from './components/SolutionSection';
import { ProcessSection } from './components/ProcessSection';
import { CredibilitySection } from './components/CredibilitySection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
const META_TITLE = 'Oscar Rodriguez — Estratega de Negocios';
const META_DESCRIPTION = 'Te ayudo a ordenar tu operación con estrategia, ingeniería y tecnología aplicada. Agenda un diagnóstico estratégico.';
const OG_IMAGE = 'https://cdn.magicpatterns.com/uploads/8iq9FdZPWhhg1moFGMfStg/Gemini_Generated_Image_vohteevohteevoht_(1)-Photoroom.png';
function setMetaTag(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`) || document.querySelector(`meta[name="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    if (property.startsWith('og:') || property.startsWith('twitter:')) {
      el.setAttribute('property', property);
    } else {
      el.setAttribute('name', property);
    }
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    document.title = META_TITLE;
    setMetaTag('description', META_DESCRIPTION);
    // Open Graph
    setMetaTag('og:title', META_TITLE);
    setMetaTag('og:description', META_DESCRIPTION);
    setMetaTag('og:image', OG_IMAGE);
    setMetaTag('og:type', 'website');
    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', META_TITLE);
    setMetaTag('twitter:description', META_DESCRIPTION);
    setMetaTag('twitter:image', OG_IMAGE);
  }, []);
  return <div className="min-h-screen bg-navy text-white font-sans selection:bg-gold/30 selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SymptomsSection data-id="element-4" />
        <DiagnosisSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <CredibilitySection data-id="element-7" />
        <ProcessSection data-id="element-8" />
        <CTASection data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}